import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { TabContent, TabPane } from "reactstrap";
import { callPost } from "utils/CommonApi";

import Constants from "common/Constants";

import AatbMainList from "components/mypage/myAatb/AatbMainList";

const AatbPrimeMain = (props) => {
    const { activeTab, aatbType, gradInfo, mmbrAatbList, setSaveAatbInfo, chk, setChk, tabChgNum } = props;

    /* 사용자 정보 */
    const loginInfo = useSelector((state) => state.loginReducer);

    //Test props end
    const headerParam = {
        user_id: loginInfo.userId,
    };

    const [courseAatbList, setCourseAatbList] = useState([]);

    useEffect(() => {
        if (Boolean(activeTab)) {
            const queryParam = {
                GRAD_CD: gradInfo.gradCd,
                SMST_CD: "",
                COURSE_GRP_CD: aatbType,
            };

            const param = {
                REQUEST_API: Constants.MYPAGE_API.GRAD_AATB_LIST,
                HTTP_METHOD: Constants.HTTP_METHOD.GET,
            };

            callPost(
                headerParam,
                param,
                (resData) => {
                    setCourseAatbList(resData.RESP_RESULT.GRAD_AATB_LIST);
                    // setFullfilled();
                },
                queryParam,
            );
        }
    }, [activeTab, tabChgNum]);

    const getMmbrCourseAatb = (type, typeValue) => {
        let mmbrAatb = [];

        if (Boolean(type)) {
            if (type === "AATB_SEQ") {
                // 교과서일련번호 조건으로 교과서 정보 조회
                typeValue = typeValue || -1;
                mmbrAatb = mmbrAatbList.filter((value) => value.AATB_SEQ === typeValue);
            } else if (type === "COURSE_GRP_CD") {
                // 과목그룹코드 조건으로 교과서 정보 조회
                typeValue = typeValue || aatbType;
                mmbrAatb = mmbrAatbList.filter((value) => value.COURSE_GRP_CD === typeValue);
            }
        }

        return mmbrAatb.length > 0 ? mmbrAatb[0] : null;
    };

    const setMmbrCourseAatb = (chgValue) => {
        if (Boolean(activeTab)) {
            // 변경 값이 없을 경우 과목코드만 추가 (선택 취소시)
            if (!Boolean(chgValue)) {
                chgValue = {
                    COURSE_GRP_CD: aatbType,
                };
            }

            // 변경 과목의 교과서가 존재시,
            let tmpList = mmbrAatbList.filter((value) => value.COURSE_GRP_CD === chgValue.COURSE_GRP_CD);

            if (tmpList.length > 0) {
                tmpList = mmbrAatbList.map((value, index) =>
                    value.COURSE_GRP_CD !== chgValue.COURSE_GRP_CD ? value : chgValue,
                );
            } else {
                tmpList = mmbrAatbList.concat(chgValue);
            }

            setSaveAatbInfo(tmpList);
        }
    };

    const getCourseAatb = (type, typeValue) => {
        let courseAatb = [];

        if (Boolean(type)) {
            if (type === "AATB_SEQ") {
                // 교과서일련번호 조건으로 과목교과서 조회
                courseAatb = courseAatbList.filter((value) => value.AATB_SEQ === Number(typeValue));
            } else if (type === "COURSE_GRP_CD") {
                // 과목그룹코드 조건으로 과목교과서 조회
                typeValue = typeValue || aatbType;
                courseAatb = courseAatbList.filter((value) => value.COURSE_GRP_CD === typeValue);
            }
        }

        return courseAatb.length > 0 ? courseAatb[0] : null;
    };

    return (
        <TabContent activeTab={activeTab}>
            {/* <PendigProgress /> */}
            <TabPane tabId={activeTab}>
                <AatbMainList
                    getCourseAatb={getCourseAatb}
                    getMmbrCourseAatb={getMmbrCourseAatb}
                    setMmbrCourseAatb={setMmbrCourseAatb}
                    courseAatbList={courseAatbList}
                    chk={chk}
                    setChk={setChk}
                />
            </TabPane>
        </TabContent>
    );
};

export default AatbPrimeMain;
